export interface BuildReportEventUrlParams {
  eventId: string;
  eventName: string;
  eventUrl: string;
  country: string;
  locale: string;
  reporterId?: string | null;
  reporterEmail?: string | null;
}

const REPORT_EVENT_PATH = '/rte/submit/report-event/';
const QA_RTE_ORIGIN = 'https://www.evbqa.com';

const LOCAL_DEV_HOSTNAMES = new Set(['localhost', '127.0.0.1', 'dev.evbqa.com']);

export function normalizeLocaleForRte(locale: string): string {
  return locale.replace(/-/g, '_');
}

export function getReportEventBasePath(hostname?: string): string {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : undefined);

  if (resolvedHostname && LOCAL_DEV_HOSTNAMES.has(resolvedHostname)) {
    return `${QA_RTE_ORIGIN}${REPORT_EVENT_PATH}`;
  }

  return REPORT_EVENT_PATH;
}

export function buildReportEventUrl(
  { eventId, eventName, eventUrl, country, locale, reporterId, reporterEmail }: BuildReportEventUrlParams,
  hostname?: string,
): string {
  const params = new URLSearchParams({
    embedded: 'true',
    event_id: eventId,
    event_name: eventName,
    event_url: eventUrl,
    country,
    locale: normalizeLocaleForRte(locale),
  });

  if (reporterId) {
    params.set('reporter_id', reporterId);
  }

  if (reporterEmail) {
    params.set('reporter_email', reporterEmail);
  }

  return `${getReportEventBasePath(hostname)}?${params.toString()}`;
}
